import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const BlocosParlamentares = () => {
  return (
    <div>
      <h1>BlocosParlamentares</h1>
    </div>
  );
};

export default BlocosParlamentares;
